<template>
  <div class="">
    <div class="flex bg-white bt b--light-gray items-start pv3">
      <div class="tl w-90 w-80-l">
        <div class="mw7">
          <p class="fs-subheading fw5">{{ title }}</p>
          <p v-if="active" class="">{{ text }}</p>
        </div>
      </div>
      <div class="w-10 w-20-l tr mt4">
        <a class="pointer" @click="toggle">
          <span class="dn dib-l">{{ $t('common.showMore') }}</span
          ><span class="ml1">
            <img
              src="~/assets/icons/ic_arrow_right.svg"
              :class="active ? 'rotate-270' : 'rotate-90'"
              class="ml2"
              width="8"
              height="13"
            />
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
  },
};
</script>
